function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg';
export function SingleGender({
  width = 11,
  height = 20,
  ...props
}) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: width,
    height: height,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#prefix__clip0)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M5.044 8.456v-6.97c-.11.109-.186.18-.255.253-.584.613-1.16 1.226-1.745 1.832-.295.303-.735.217-.783-.173-.02-.158.069-.382.179-.505.556-.62 1.14-1.212 1.717-1.818l.736-.772c.391-.404.824-.404 1.216 0 .804.837 1.6 1.681 2.398 2.518l.103.108c.199.238.213.484.034.679-.186.202-.447.202-.667-.03a175.842 175.842 0 01-1.58-1.659c-.13-.137-.24-.288-.364-.433-.02.03-.041.036-.062.05v6.906c3.23.353 5.332 3.311 4.995 6.392-.336 3.088-2.782 5.267-5.702 5.159-2.735-.101-5.078-2.497-5.25-5.325-.192-3.08 1.876-5.858 5.03-6.212zm.46 10.592c2.508.014 4.59-2.158 4.603-4.791.014-2.655-2.026-4.856-4.52-4.87-2.605-.015-4.673 2.1-4.693 4.812-.014 2.662 2.047 4.834 4.61 4.849z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "prefix__clip0"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M0 0h11v20H0z"
  }))));
}
//# sourceMappingURL=SingleGender.js.map